var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 9.564,
    x2: 23,
    y1: 12,
    y2: 12,
    strokeWidth: 1.993
  }), /*#__PURE__*/React.createElement("polyline", {
    transform: "matrix(1.204 0 0 1.465 3.263 .5792)",
    points: "13.81 10.45 16.47 7.794 13.81 5.138",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.69 16.71v4.714c0.03041 0.8277-0.4894 1.53-1.163 1.571h-10.46c-0.6733-0.04181-1.192-0.7439-1.162-1.571v-18.86c-0.03089-0.8276 0.4887-1.53 1.162-1.571h10.46c0.6735 0.04125 1.193 0.7435 1.163 1.571v4.714",
    strokeWidth: 2.001
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.c7910c8433e8fd17c3c1c0b42f8763ab.svg";
export { ForwardRef as ReactComponent };